import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchCurrentPantry,
  createPantry,
  updatePantry
} from '../../../sagas/routines';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null
};

export const fetchCurrentPantryHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createOrUpdatePantryHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

export default createReducer(initialState, {
  ...fetchCurrentPantryHandler(fetchCurrentPantry),
  ...createOrUpdatePantryHandler(createPantry),
  ...createOrUpdatePantryHandler(updatePantry)
});
